import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import './index.css';
import { Capacitor } from '@capacitor/core';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Recover from stale chunks after a deploy (FRE-37): reload once, guarded against loops.
const PRELOAD_RELOAD_KEY = 'fb-preload-reload';
window.addEventListener('vite:preloadError', (event) => {
  // FND-08: offline a reload cannot fetch anything new; let the route error boundary show a retry instead.
  if (!navigator.onLine) return;
  if (sessionStorage.getItem(PRELOAD_RELOAD_KEY)) return;
  sessionStorage.setItem(PRELOAD_RELOAD_KEY, '1');
  event.preventDefault();
  window.location.reload();
});
// Once the app has run cleanly for a while, re-arm the guard so a later deploy in this tab can recover too.
window.setTimeout(() => sessionStorage.removeItem(PRELOAD_RELOAD_KEY), 30000);

// Register PWA Service Worker (web only; skipped in the Capacitor native webview)
if ('serviceWorker' in navigator && !Capacitor.isNativePlatform()) {
  const hadController = !!navigator.serviceWorker.controller;
  let reloading = false;
  // Never reload mid-practice (Focus HUD / tab player); wait until the user navigates away.
  const isPracticeRoute = () => /^\/(routines\/[^/]+\/hud|tabs\/[^/]+|practice\/(chords|scale))\/?$/.test(window.location.pathname);
  const reloadWhenIdle = () => {
    if (reloading) return;
    if (!isPracticeRoute()) {
      reloading = true;
      window.location.reload();
      return;
    }
    window.setTimeout(reloadWhenIdle, 3000);
  };

  // Only reload when an existing (old) controller is replaced, not on first install.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController) reloadWhenIdle();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        console.log('FretBoard Service Worker registered:', registration.scope);
        registration.update().catch(() => {});
      })
      .catch((err) => {
        console.warn('FretBoard Service Worker registration failed:', err);
      });
  });
}
